module.exports = __webpack_public_path__ + "img/tulpan_60.3eabb996.svg";